let messages = document.querySelectorAll('.message-container .message');
let modal = document.querySelector('.messages-modal');
let modalBackdrop = document.querySelector('.messages-modal-left-slide-in-backdrop');

for (let message of messages) {
  let messageLink = message.querySelector('.message-modal-link');
  if (!messageLink) {
    continue;
  }
  messageLink.addEventListener('click', (evt) => {
    evt.preventDefault();
    modalBackdrop.classList.add('active');
    modal.classList.remove('wrapper-hidden');

    let icon = modal.querySelector('#messageModalIcon');
    let header = modal.querySelector('#messageModalHeader');
    let body = modal.querySelector('#messageModalBody');
    let link = modal.querySelector('#messageModalLink');

    icon.classList.value = '';
    icon.classList.add(message.dataset.icon);
    header.innerHTML = message.dataset.title;
    body.innerHTML = message.dataset.body;
    link.href = message.dataset.url;
    link.innerHTML = message.dataset.urlText || message.dataset.url.replace(/^https?:\/\//, '');
  });
}

let modalCloseButton = modal.querySelector('.hide-messages-modal');
modalCloseButton.addEventListener('click', () => {
  modalBackdrop.classList.remove('active');
  modal.classList.add('wrapper-hidden');
});

modalBackdrop.addEventListener('click', () => {
  modalBackdrop.classList.remove('active');
  modal.classList.add('wrapper-hidden');
});
